import { FC } from 'react';
import { AcceptFormProps } from './types';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { BaseError } from 'types';
import { EdmsService } from 'services/EdmsService';

export const AcceptForm: FC<AcceptFormProps> = ({ id, concurrencyStamp, name }) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const cancelHandler = () => {
    dispatch(modalActions.closeModal());
  };

  const { mutateAsync: contractSignature } = useMutation(
    ['contractSignature'],
    () => EdmsService.contractSignature({ id, concurrencyStamp }),
    {
      onSuccess: () => {
        toast.success('Документ успешно принят.');
        queryClient.refetchQueries('getContracts');
        cancelHandler();
      },
      onError: (data: AxiosError<BaseError>) => {
        data.response?.data.errors
          ? Object.values(data.response?.data.errors).forEach((errors) =>
              errors.forEach((message) => toast.error(message))
            )
          : toast.error(data.response?.data.detail);
      },
    }
  );

  return (
    <div className="flex h-full w-full flex-col justify-between p-4 sm:min-w-[500px] sm:p-0">
      <p className="headline-normal mt-2 leading-6 text-text-100">
        Нажимая «Принять», вы соглашаетесь с условиями {name}
      </p>
      <div className="mt-6 flex flex-col-reverse gap-6 sm:flex-row sm:justify-end">
        <Button
          variant={ButtonVariant.GHOST}
          onClick={cancelHandler}
          className="paragraphs-bold mb-1 w-full max-w-full border border-solid border-text-50 !text-text-100 sm:w-[130px]"
        >
          ОТМЕНА
        </Button>
        <Button
          className="paragraphs-bold mb-1 w-full max-w-full sm:w-[190px]"
          onClick={() => contractSignature()}
        >
          ПРИНЯТЬ
        </Button>
      </div>
    </div>
  );
};
